/**
 * Retail POS Cash & Change UX projection.
 *
 * Pure presentation contract.
 *
 * Authorities:
 *
 * - amountDue:
 *     comes from the authoritative Receipt projection;
 *
 * - cashReceived:
 *     represents the physical amount tendered by the customer;
 *
 * - cashChange:
 *     is an UX-only projection.
 *
 * This module owns no:
 *
 * - Payment;
 * - Receipt;
 * - persistence;
 * - accounting;
 * - Cash Session;
 * - API call;
 * - business engine.
 */


export function resolveRetailPOSCashChange({
  amountDue,
  cashReceived,
} = {}) {
  const normalizedAmountDue =
    normalizeMoney(
      amountDue,
      "amountDue"
    );

  const normalizedCashReceived =
    normalizeMoney(
      cashReceived,
      "cashReceived"
    );

  return roundMoney(
    Math.max(
      0,
      normalizedCashReceived
        - normalizedAmountDue
    )
  );
}


export function canSubmitRetailPOSCashPayment({
  amountDue,
  cashReceived,
} = {}) {
  const normalizedAmountDue =
    normalizeMoney(
      amountDue,
      "amountDue"
    );

  const normalizedCashReceived =
    normalizeMoney(
      cashReceived,
      "cashReceived"
    );

  if (normalizedAmountDue <= 0) {
    return false;
  }

  return (
    normalizedCashReceived
      >= normalizedAmountDue
  );
}


function normalizeMoney(
  value,
  fieldName
) {
  if (
    value === null
    || value === undefined
    || value === ""
  ) {
    throw new TypeError(
      `${fieldName} must be a valid monetary amount.`
    );
  }

  const normalized =
    Number(
      typeof value === "string"
        ? value.replace(",", ".")
        : value
    );

  if (
    !Number.isFinite(normalized)
    || normalized < 0
  ) {
    throw new TypeError(
      `${fieldName} must be a valid monetary amount.`
    );
  }

  return roundMoney(
    normalized
  );
}


function roundMoney(
  value
) {
  return (
    Math.round(
      (
        Number(value)
        + Number.EPSILON
      )
      * 100
    )
    / 100
  );
}
